import { useEffect, useState } from "react";
import Button from "../../components/button/Button";
import PhoneFrame from "../../components/layout/PhoneFrame";
import { SendIdentityCodePage } from "../../router/path-route/PathRoute";
import Logo from "../../assets/images/logo-splash.png";
import skyline from "../../assets/images/splash-skyline.png";
import DownloadAppDrawer from "../../components/drawer/DownloadAppDrawer";
import {
  SPLASH_DOWNLOAD_LATER_KEY,
  isAndroidDevice,
} from "../../utils/device";

const SPLASH_MESSAGE =
  "راننده گرامی جهت تسهیل در امور ثبت نام لطفا اپلیکیشن رانندگان اسکب را دانلود فرمائید.";

export default function Start() {
  const [showDrawer, setShowDrawer] = useState(false);

  useEffect(() => {
    const skipped = localStorage.getItem(SPLASH_DOWNLOAD_LATER_KEY) === "1";
    if (isAndroidDevice() && !skipped) {
      setShowDrawer(true);
    }
  }, []);

  const TermsAndRules = () => {
    window.location.href = "https://scab.ir/privacy-policy/";
  };

  const handleLater = () => {
    localStorage.setItem(SPLASH_DOWNLOAD_LATER_KEY, "1");
    setShowDrawer(false);
  };

  return (
    <PhoneFrame className="bg-scabSplash" scroll={false}>
      <div className="h-full flex flex-col relative overflow-y-auto overflow-x-hidden phone-scroll">
        <img
          src={skyline}
          alt=""
          className="absolute inset-0 w-full h-full object-cover object-bottom pointer-events-none"
        />
        <div className="relative z-10 h-[8px] bg-scabDarkYellow shrink-0" />
        <div className="relative z-10 flex-1 flex flex-col items-center px-8 pt-16 pb-8">
          <img src={Logo} alt="اسکب" className="w-[220px] h-auto mt-8" />
          <div className="text-scabWhite text-xxlarge font-IRANSans mt-20 text-center">
            به اسکب خوش آمدید.
          </div>
          <div className="w-full mt-16">
            <Button
              title="ورود | ثبت نام"
              bgButton={true}
              nextPage={SendIdentityCodePage}
            />
          </div>
          <div className="w-full text-scabWhite text-medium flex justify-center items-center font-IRANSans mt-10 text-center leading-7">
            با ثبت نام در اسکب،
            <span
              className="text-scabRed mx-1 cursor-pointer"
              onClick={TermsAndRules}
            >
              شرایط و قوانین
            </span>
            را می‌پذیرم.
          </div>
        </div>
      </div>
      <DownloadAppDrawer
        open={showDrawer}
        onClose={() => setShowDrawer(false)}
        onLater={handleLater}
        showClose={true}
        closeOnBackdrop={true}
        showLater={true}
        message={SPLASH_MESSAGE}
      />
    </PhoneFrame>
  );
}
